import React, { useState, useEffect, useRef } from "react";
import OwlNav from "../../../components/shared/OwlNav";
import { IsEmpty, convertSlugToTitle, getParameterByName, escapeDoubleQuotes, secondToJsonLd, sanitizeAndProcessHtml } from "../../../util/commonFunctions";
import HelmetComponent from "../../../components/shared/Helmet";
import Breadcrumb from "../breadcrumb";
import { getEnv } from "../../../../helpers/env";

function Navigation({ listing = [], title = "", pathName, onTierClicked = () => { }, followCompanyClicked = () => { }, isFollowing, unFollowCompanyClicked = () => { }, hierarchy = [], contents = [] }) {
  function getPathFromUrl(url) {
    const removeQuery = url && url.split("?")[0];
    return removeQuery;
  }
  const url = pathName && pathName.substring(pathName.lastIndexOf('/') + 1)
  const ref = useRef(null);
  const finalUrl = getPathFromUrl(url);

  const [height, setHeight] = useState(0);
  const [canonicalUrl, setCanonicalUrl] = useState(null);
  const hierarchyArr = hierarchy ? hierarchy : [];

  const generateStructuredData = () => {
    let relatedTopcis = null;
    let pageContents = null;

    if(listing && listing.length > 0){
      relatedTopcis = `{
        "@type": "ItemList",
        "name": "Related Topics",
        "description": "Additional related topics to contents of the page.",
        "itemListElement": [
          ${
            listing.map((relatedTopic, i) => {
              return `{
                "@type": "ListItem",
                "position": ${i},
                "url": "${getEnv('BASE_URL') + escapeDoubleQuotes(relatedTopic.tierInUrl)}?topicID=${relatedTopic.id}",
                "name": "${escapeDoubleQuotes(relatedTopic.name)}"
              }`
            })
          }
        ]
      }`;
    }
    if(contents && contents.length > 0 && contents[0]){
      pageContents = contents[0].map(content => {

        let about = content?.secondaryTopics?.map((topic) => {
          const filteredTopics = (listing && listing.length > 0) && listing.filter((relatedTopic) => relatedTopic.id === topic.id);
          const tierInUrl = (filteredTopics && filteredTopics.length > 0 )? filteredTopics[0].tierInUrl + '?topicID=' + filteredTopics[0].id : '';
          
          if(filteredTopics && filteredTopics.length > 0){
            return `{
              "@id": "${getEnv('BASE_URL') + tierInUrl}",
              "name": "${escapeDoubleQuotes(topic.name)}" 
            }`
          }else {
            return null;
          }
        }).filter(item => item !== null);

        let ind_content =  `{
          "@type": "VideoObject",
          "name": "${escapeDoubleQuotes(content.title)}",
          "thumbnailUrl": "${content.imageUrl}",
          "uploadDate": "${new Date(content.publish_date).toISOString()}",
          "duration": "${secondToJsonLd(content.duration)}",
          "regionsAllowed": "AU",
          "contentUrl": "${content.videoUrl.progressive ? content.videoUrl.progressive : 'a' }"
        }`;

        let all_about = `"about": [
          {
            "@id": "${getEnv('BASE_URL') + title?.tierInUrl + `?topicID=${title?.id}`}",
            "name": "${title?.name}"
          }${(about && about.length > 0) ? ',' : ''}
          ${about}
        ]`;

        (about && about.length > 0 && title?.tierInUrl && title?.id && title?.name) && ind_content.concat(",", all_about);
        return  ind_content;
      })
    }

    return `{"@context":"https://schema.org", "@graph": [${relatedTopcis ? relatedTopcis + ',' : ''} ${pageContents ? pageContents : ''}]}`;
  }

  useEffect(() => {
    let search = window.location.search;
    let topicID = getParameterByName("topicID", search || url);
    let canonicalUrl = getEnv('BASE_URL') + window.location.pathname + `?topicID=${topicID}`;

    setCanonicalUrl(canonicalUrl);
    setTimeout(() => {
      setHeight(ref?.current?.clientHeight)
    }, 1000)
  }, [])

  const toggleText = () => {
    let descHgt = document.querySelector('.company-info-toggle');
    let infoHeight = descHgt.scrollHeight;
    let btnText = document.querySelector(".toggle-text");
    if (btnText.innerHTML === "show more") {
      btnText.innerHTML = "show less";
    } else {
      btnText.innerHTML = "show more";
    }
    descHgt.style.setProperty('--max-height', infoHeight + 'px');
    descHgt.classList.toggle("is-visible");
  }

  return (
    <React.Fragment>
      <HelmetComponent
        title={"On Demand " +(finalUrl && convertSlugToTitle(finalUrl) || (title && title.name)) + " | ausbiz"}
        subject={(finalUrl && convertSlugToTitle(finalUrl) || (title && title.name)) || (title && title.name)}
        description={title && title.metaDescription ? title.metaDescription : ''}
        customDescription={title && title.description ? title.description : ''}
        noIndex="false"
        topicJsonLd={true}
        topicJsonLdObject={hierarchyArr}
        structuredData={generateStructuredData()}
        canonicalUrl={canonicalUrl}
      />
      <div className="navigation-title-wrap">
        <div className="container">
          {
            <Breadcrumb
              hierarchy={hierarchyArr}
            />
          }
          <div className="navigation-title-block">
            <div className="navigation-title">
              <h2>{title && title.name}</h2>
              {title != null ?
                isFollowing ?
                  <a href="javascript:void(null);" onClick={() => unFollowCompanyClicked()} className="unfollow-btn">Following</a>
                  :
                  <a href="javascript:void(null);" onClick={() => followCompanyClicked()} className="follow-btn">Follow</a>
                : null
              }
            </div>
            <div className="navigation-info">
              <div className={title != null && height >= 40 ? "company-info-toggle company-info-active" : "company-info-toggle"} ref={ref}>
                <p>
                  {title && title.description &&
                    <span dangerouslySetInnerHTML={{__html: sanitizeAndProcessHtml(title.description)}} ></span>
                  }
                </p>
              </div>
              {title != null && height >= 40 && <span className="toggle-text" onClick={toggleText}>show more</span>}
            </div>
          </div>
        </div>
      </div>
      <div className="nav-links">
        <div className="container">
          {!IsEmpty(listing) && Array.isArray(listing) && (
            <OwlNav data={listing} onTierClicked={onTierClicked} isCompanyPage={false} />
          )}
        </div>
      </div>
    </React.Fragment>
  );
}

export { Navigation };
